import { Injectable } from '@angular/core';
import { HttpService } from '../../services/http/http.service';
import { Path } from '../../utils/constant/paths';
import * as Constant from 'src/app/utils/constant';
import { HelperService } from 'src/app/services';
import * as _ from 'lodash';
import { environment } from 'src/environments/environment';
import { of as observableOf } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(
    private http: HttpService,
    private helper: HelperService
  ) { }


  updateLastChangePasswordDate(params) {
    // NOTE: this is updated if session is handled by us. For now, session is handled by AWS Cognito.
    return observableOf(
      {
        "message":"Success",
        "responseData":[]
     }
    )
  }

  getUserData(data:any){
    return this.http.post(Path.LOGIN.GET_USER_DETAILS, data)
  }


}
